/**
 * Utilitaires pour la gestion des statuts d'application
 */

/**
 * Vérifie si une application est validée (approuvée)
 * Accepte les statuts APPROVED, CONFIRMED et COMPLETED
 */
export function isApplicationApproved(status: string): boolean {
  return status === 'APPROVED' || status === 'CONFIRMED' || status === 'COMPLETED';
}

/**
 * Vérifie si une application est en attente de validation
 */
export function isApplicationPending(status: string): boolean {
  return status === 'PENDING' || status === 'NEW' || status === 'REVIEWING';
}

/**
 * Vérifie si une application est rejetée
 */
export function isApplicationRejected(status: string): boolean {
  return status === 'REJECTED';
}
